import React, { useState, useEffect } from 'react';
import { Dialog } from '@mui/material';
import { ReactComponent as CloseIcon } from 'assets/img/svg/CrossIcon.svg';
import { DisplayViewData } from '../common';
import { emptyVendorForm, vendorDetail } from './constant';
import AButton from 'views/pages/manage/common/form-fields-mui/AButton';

const VendorDetailPopup = ({ open, onClose, vendorDetails, setGlobalVendorForm, isEdit, action }) => {

    const [form, setForm] = useState(emptyVendorForm);
console.log("Vendor Details in Popup: ", form);
    useEffect(() => {
        if (vendorDetails) {
            setForm((prev)=>({...prev, ...vendorDetails}));
        }
    }, [vendorDetails]);

    const closeDialog = () => {
        setForm({});
        onClose();
    };

    const saveHandler = async (form) => {
        
        try {
            const updatedForm = {
                ...form,
                qty: Number(form?.qty) || 0
            };

            setGlobalVendorForm(updatedForm);

            closeDialog();
        } catch (err) {
            console.error("Error saving vendor details: ", err);
        }
    };
    const isSaveDisabled = () => {
        for (let key in form) {
            if (!form[key]) {
                return true;
            }
        }
        return false;
    }

    return (
        <Dialog open={open} fullWidth maxWidth="md">
            <div className='p-3'>

                <div className='d-flex justify-content-between'>
                    { isEdit ? <h3>Add Vendor Details</h3> : <h3> Vendor Details</h3> }
                    <CloseIcon className='cursor' onClick={closeDialog} />
                </div>

                <DisplayViewData
                    dataArray={vendorDetail ?? []}
                    isEdit={isEdit}
                    action={action}
                    rowFormHandler={(key, val) => {
                        setForm(prev => ({
                            ...prev,
                            [key]: val
                        }));
                    }}
                    form={form}
                    setForm={setForm}
                />

                {action !== 'view' && isEdit && (
                    <div className='d-flex justify-content-end mt-3'>
                        <AButton variant="outline" onClick={closeDialog} className='mr-2'>Cancel</AButton>
                        <AButton variant="primary_filled" disabled={isSaveDisabled()} onClick={() => saveHandler(form)}>Save</AButton>
                    </div>

                )}
            </div>
        </Dialog>
    );
};

export default VendorDetailPopup;